import styled from "styled-components";

export const BreadcrumbContainer = styled.div`
  padding-inline: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 31px;
  padding: 8px 50px;
  gap: 32px;
`;

export const CustomBreadcrumbWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  & > nav > button {
    font-weight: bold;
  }
  
`;

